const players = state => state.players
const search = state => state.search
const country = state => state.country
const hasPlayers = state => state.players.length > 0
const filter = state => state.filter
const isLoading = state => state.loading
const pagination = state => state.pagination
const dragging = state => state.dragging

export default {
  players,
  search,
  country,
  hasPlayers,
  filter,
  isLoading,
  pagination,
  dragging
}



// WEBPACK FOOTER //
// ./src/store/modules/players/getters.js